import { setInstanceByEnvType } from "src/utils/helpers/requestApi/isServer";

interface AnalogsParams {
  product_slug: string;
  city_slug: string;
}

export interface AnalogsSchema {
  all_analogs_url: string;
  items: AnalogsItemsSchema[];
}

interface AnalogsItemsSchema {
  is_advertisement: boolean;
  name: string;
  company: string;
  country: string;
  offers_amount: number;
  min_price: number;
  image: string;
  slug: string;
  full_slug: string;
}

export const getAnalogs = (params: AnalogsParams) =>
  setInstanceByEnvType().get<AnalogsSchema>(
    "/v2/catalog/product_page/analogs",
    {
      params,
    }
  );
